import React, { useEffect, useState } from 'react';
import { Loader, Dimmer, Card, Statistic, Label } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { GetReservations } from '../../../api/services/pms';
import { onWarning, onError } from '../../../components/shared/messages';
import moment from 'moment';
import _ from 'lodash';
import { useTextResources } from '../../../language';

export const generalStatsWidget = ({ HotelIds }) => {
	const [reservationsDataForCards, setReservationsDataForCards] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const text = useTextResources();

	useEffect(() => {
		if (!HotelIds.length) return;

		(async () => {
			try {
				setIsLoading(true);
				const [
					reservationsByCheckInDate,
					reservationsByCheckOutDate,
					reservationsStayOver,
				] = await Promise.all([
					GetReservations({
						HotelIds,
						ExactCheckInDate: moment().toISOString(),
					}),
					GetReservations({
						HotelIds,
						ExactCheckOutDate: moment().toISOString(),
					}),
					GetReservations({
						HotelIds,
						ToCheckInDate: moment().subtract(1, 'day').toISOString(),
						MinCheckoutDate: moment().add(1, 'day').toISOString(),
					}),
				]);

				const data = {
					byCheckIn: {
						title: text('Arrival'),
						icon: 'icon-hotel-reception-bell',
						color: '#87BD49',
						rooms: reservationsByCheckInDate.length,
						adults: _.sumBy(reservationsByCheckInDate, 'Adults'),
						children: _.sumBy(reservationsByCheckInDate, 'Children'),
						infants: _.sumBy(reservationsByCheckInDate, 'Infants'),
					},
					byCheckOut: {
						title: text('Departure'),
						icon: 'sign-out',
						color: '#C81B56',
						rooms: reservationsByCheckOutDate.length,
						adults: _.sumBy(reservationsByCheckOutDate, 'Adults'),
						children: _.sumBy(reservationsByCheckOutDate, 'Children'),
						infants: _.sumBy(reservationsByCheckOutDate, 'Infants'),
					},
					byStayOver: {
						title: text('Stayover'),
						icon: 'bed',
						color: '#03A2B7',
						rooms: reservationsStayOver.length,
						adults: _.sumBy(reservationsStayOver, 'Adults'),
						children: _.sumBy(reservationsStayOver, 'Children'),
						infants: _.sumBy(reservationsStayOver, 'Infants'),
					},
				};
				setReservationsDataForCards(data);
				setIsLoading(false);
			} catch (error) {
				error.status === 400 ? onWarning(error) : onError(error);
				setIsLoading(false);
			} finally {
				setIsLoading(false);
			}
		})();
	}, [HotelIds]);

	return (
		<>
			{isLoading ? (
				<Dimmer active inverted>
					<Loader inline='centered' size='medium' />
				</Dimmer>
			) : (
				<Card.Group stackable centered>
					{Object.values(reservationsDataForCards).map((cardData, i) => (
						<Card
							key={i}
							color={cardData.color}
							raised
							style={{ maxWidth: 150, marginLeft: '2em' }}
						>
							<Card.Content>
								<Card.Header>
									<Label
										style={{ backgroundColor: cardData.color, color: '#fff' }}
										ribbon
										icon={cardData.icon}
										content={cardData.title}
									/>
								</Card.Header>
								<Card.Description>
									<Statistic
										horizontal
										size='small'
										value={cardData.rooms}
										label={text('Rooms')}
									></Statistic>
								</Card.Description>
								<Card.Meta>
									{`${text('Pax')}: ${cardData.adults} / ${
										cardData.children
									} / ${cardData.infants}`}
								</Card.Meta>
							</Card.Content>
						</Card>
					))}
				</Card.Group>
			)}
		</>
	);
};

generalStatsWidget.propTypes = {
	HotelIds: PropTypes.array,
};
